import React from "react";
import { BreadCrumbsInterface, ProductInterface } from "../../interfaces/product/product.interface";
import { formatSpecialNumber, getFutureDateISO } from "../../utils";

interface MetaBlockProps {
    product: ProductInterface;
}

export const MetaBlock: React.FC<MetaBlockProps> = ({ product }) => {
    const getStockString = () => {
        if(product.stockStatusId == 7) return <><link itemProp="availability" href="//schema.org/InStock" />InStock</>;
        if(product.stockStatusId == 6) return <><link itemProp="availability" href="//schema.org/InStock" />InStock</>;
        if(product.stockStatusId == 5) return <><link itemProp="availability" href="//schema.org/OutOfStock" />OutOfStock</>;
        if(product.stockStatusId == 8) return <><link itemProp="availability" href="//schema.org/PreOrder" />PreOrder</>;
        return <><link itemProp="availability" href="//schema.org/SoldOut" />SoldOut</>;
    }

    return (
        <div className="hidden">
            <div itemScope itemType="//schema.org/Product" id="content">
                { product.images.map((i, j) => <link key={ j } itemProp="image" href={ i.big }/>) }
                <meta itemProp="name" content={ product.name }/>
                <span itemProp="model">{ product.name }</span>
                <meta itemProp="brand" content={ product.brand }/>
                {/*<meta itemProp="category" content="<?php echo $category_url; ?>" />*/ }
                <span itemProp="description">{ product.description || product.name }</span>
                <link itemProp="url" href={ product.url }/>
                <span itemProp="sku">{ product.sku }</span>
                <span itemProp="mpn">{ product.sku }</span>
                <div itemProp="offers" itemScope itemType="//schema.org/Offer">
                    <meta itemProp="price" content={ formatSpecialNumber(product.specialPrice || product.price) }/>
                    <meta itemProp="priceCurrency" content="MDL"/>
                    <meta itemProp="priceValidUntil" content={ getFutureDateISO() }/>
                    { getStockString() }
                    <link itemProp="url" href={ product.url }/>
                </div>
                <div itemProp="additionalProperty" itemScope itemType="https://schema.org/PropertyValue">
                    <meta itemProp="name" content="Rata"/>
                    <meta itemProp="value" content={ String(product.minCredit?.monthly) || '' }/>
                    <meta itemProp="unitText" content="MDL/Luna"/>
                </div>
                <div itemProp="aggregaterating" itemScope itemType="//schema.org/AggregateRating">
                    <img width="83" height="15" className="lazy"
                         src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                         data-src="catalog/view/theme/default/image/stars-5.png" alt="Best choice" title="Best choice"/>
                    <span itemProp="ratingValue">5</span>
                    <span itemProp="reviewCount">{ Math.round(product.id / 100000) }</span>
                </div>
                <div itemProp="review" itemScope itemType="//schema.org/Review" className="review-list">
                    <span itemProp="author">smart.md</span>
                    <time itemProp="datePublished" dateTime="2013-01-12"></time>
                    <div className="rating" itemProp="reviewRating" itemScope itemType="//schema.org/Rating">
                        <meta itemProp="worstRating" content="1"/>
                        <meta itemProp="ratingValue" content="5"/>
                        <meta itemProp="bestRating" content="5"/>
                    </div>
                    <div className="text" itemProp="reviewBody"></div>
                </div>
                <ol itemScope itemType="http://schema.org/BreadcrumbList">
                    { product.breadcrumbs.map((breadCrumb: BreadCrumbsInterface, i) =>
                        <li key={ i } itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                            <a itemProp="item" href={ breadCrumb.link }>
                                <span itemProp="name">{ breadCrumb.name }</span></a>
                            <meta itemProp="position" content={ String(i + 1) }/>
                        </li>
                    ) }
                </ol>
            </div>
        </div>
    )
}